import React, { useState } from 'react';
import {
  View, Image, TextInput, ActivityIndicator,
} from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { useDispatch, useSelector } from 'react-redux';

import logo_purple from '../../../assets/images/logo_purple.png';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import { inputLogin } from '../../../data/dataLogin';
import { login } from '../../../redux/actions/studentActions';
import styles from './styles';

const LoginStudent = ({ navigation }) => {
  const { isLoading, isError } = useSelector((state) => state.student);
  const dispatch = useDispatch();
  const [visiblePass, changeVisibility] = useState(false);
  const [user, changeUser] = useState({ ...inputLogin });
  const handleLogin = () => {
    dispatch(login(user, navigation));
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Login Aluno" navigation={navigation} />
      <Image style={styles.imageLogo} source={logo_purple} />
      <View style={styles.viewForm}>
        <View>
          <TextInput
            value={user.email}
            onChangeText={(new_email) => changeUser({ ...user, email: new_email })}
            placeholder="Email"
            keyboardType="email-address"
            style={styles.input}
          />
          <Icon name="person-outline" style={styles.inputIcon} />
        </View>
        <View>
          <TextInput
            value={user.pass}
            onChangeText={(new_pass) => changeUser({ ...user, pass: new_pass })}
            placeholder="Senha"
            secureTextEntry={!visiblePass}
            style={styles.input}
          />
          <Icon name="settings-outline" style={styles.inputIcon} />
          <Icon
            name={visiblePass ? 'eye-off' : 'eye'}
            onPress={() => changeVisibility(!visiblePass)}
            style={[styles.inputIcon, styles.inputIconEye]}
          />
        </View>
        <AppButton
          disableDefaultColor
          size="bold"
          label="ESQUECI A MINHA SENHA"
          onPress={() => navigation.navigate('Esqueci Minha Senha', { type: 'ALUNO' })}
          style={styles.buttonSmall}
          labelStyle={styles.textSmall}
        />
        {isError && <AppText style={styles.textError}> Email e/ou Senha Invalidos! </AppText>}

        <AppButton
          primary
          size="bold"
          disabled={isLoading || user.email === '' || user.pass === ''}
          label={isLoading ? <ActivityIndicator color="#FFF" size={pixelDimensions(7)} /> : 'ENTRAR'}
          labelStyle={styles.textButton}
          onPress={() => !isLoading && handleLogin()}
          style={styles.button}
        />
        <AppButton
          size="bold"
          label="VOLTAR"
          labelStyle={styles.textButton}
          onPress={() => navigation.navigate('Login', { screen: 'Base' })}
          style={styles.button}
        />
      </View>
    </View>
  );
};

export default LoginStudent;
